import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import reportWebVitals from "./reportWebVitals";
import { Toaster } from "react-hot-toast";
import AppProvider from "./Context/Provider";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.Fragment>
    <AppProvider>
      <App />
    </AppProvider>
    <Toaster />
  </React.Fragment>
);


reportWebVitals();
